import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiMenu, FiBell, FiUser } from 'react-icons/fi';

const Header = ({ toggleSidebar }) => {
  const { user } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200 px-4 md:px-6 py-3 md:py-4 sticky top-0 z-30">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 md:gap-4">
          <button 
            className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center" 
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <FiMenu size={24} />
          </button>
          <h2 className="text-base md:text-xl font-bold text-gray-900 truncate">
            <span className="hidden sm:inline">Institute Portal</span>
            <span className="sm:hidden">Portal</span>
          </h2>
        </div>

        <div className="flex items-center gap-2 md:gap-4">
          <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center">
            <FiBell size={20} />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          <div className="flex items-center gap-2 md:gap-3 pl-2 md:pl-4 border-l border-gray-200">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-600 text-white flex items-center justify-center">
              <FiUser size={18} />
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-semibold text-gray-900">{user?.name}</p>
              <p className="text-xs text-gray-600">{user?.role === 'institute' ? 'Admin' : 'Teacher'}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

